
var autocompleteController = null;

window.search =
{
    init: function ()
    {
        var searchForms = document.querySelectorAll("form[data-search-form]");

        searchForms.forEach(searchForm =>
        {
            search.bindForm(searchForm);
        });

        var lastAutocomplete = localStorage.getItem("lastAutocomplete");

        if (!lastAutocomplete)
            return;

        searchForms.forEach(async searchForm =>
        {
            var autocompleteContainer = document.querySelector(searchForm.dataset.searchAutocompleteTarget);

            if(!autocompleteContainer)
                return;

            var lastSearchString = await localization.get("search.vysledkyposlednihohledani");
            var html = '<div class="row mt-5 rounded-5 bg-body-tertiary p-4">';
            html += '<div class="col-12 text-center">';
            html += '<p class="h3 border-bottom pb-3">' + lastSearchString + '</p>';
            html += '</div>'; // col-12
            html += '<div class="col-12">';
            html += lastAutocomplete;
            html += '</div>'; // col-12
            html += '</div>'; // row

            autocompleteContainer.innerHTML += html;

            price.asyncPrice();

            var customEvent = new CustomEvent("onAutocompleteChanged", { detail: { target: searchForm.dataset.searchAutocompleteTarget, node: autocompleteContainer } });

            document.dispatchEvent(customEvent);
        });
    },
    bindForm: function (form)
    {
        var input = form.querySelector(":scope input[type='search']");
        var button = form.querySelector(":scope button[data-search]");

        var timeout = null;

        input.addEventListener("input", function (e)
        {
            if (timeout)
                clearTimeout(timeout);

            if (input.value.trim().length == 0)
            {
                search.clearAutocomplete(form);

                return;
            }

            timeout = setTimeout(function ()
            {
                search.processAutocomplete(input.value, form);
            }, 200);
        });

        input.addEventListener("keydown", function (e)
        {
            if (e.code != "Enter")
                return;

            if (input.value.trim().length == 0)
            {
                search.clearAutocomplete(form);

                return;
            }

            processSearch(input.value, form);
        });

        if (!button)
            return;

        button.addEventListener("click", function (e)
        {
            search.processSearch(input.value, form);
        });
    },
    clearAutocomplete: function (form)
    {
        if (autocompleteController)
            autocompleteController.abort("stop");

        var autocompleteContainer = document.querySelector(form.dataset.searchAutocompleteTarget);

        var customEvent = new CustomEvent("onAutocompleteChanged", { detail: { target: form.dataset.searchAutocompleteTarget, node: autocompleteContainer } });

        if (autocompleteContainer)
            autocompleteContainer.innerHTML = "";

        document.dispatchEvent(customEvent);
    },
    processAutocomplete: function (value, form)
    {
        var autocompleteContainer = document.querySelector(form.dataset.searchAutocompleteTarget);

        if (!autocompleteContainer)
            return;

        var url = autocompleteContainer.dataset.autocomplete + "?q=" + value;

        if (autocompleteController)
            autocompleteController.abort("stop");

        autocompleteController = new AbortController();

        fetch(url,
        {
            method: "GET",
            signal: autocompleteController.signal
        })
        .then(response =>
        {
            if (!response.ok)
                throw new Error('Network response was not ok.');

            return response.text();
        })
        .then(data =>
        {
            var autocompleteContainer = document.querySelector(form.dataset.searchAutocompleteTarget);

            var customEvent = new CustomEvent("onAutocompleteChanged", { detail: { target: form.dataset.searchAutocompleteTarget, node: autocompleteContainer } });

            if (autocompleteContainer)
            {
                localStorage.setItem("lastAutocomplete", data);

                autocompleteContainer.innerHTML = data;

                var autoCompleteNode = autocompleteContainer.querySelector(":scope .autocomplete");

                if (autoCompleteNode.dataset.notFound !== undefined)
                    localStorage.removeItem("lastAutocomplete");
            }

            document.dispatchEvent(customEvent);

            images.load(() =>
            {
                // po načtení obrázků chceme překreslit velikost zobrazení, aby nebyl scrollbar
                document.dispatchEvent(customEvent);
            });
            price.asyncPrice();
        })
        .catch(error =>
        {
            if (error === "stop")
                return;

            console.error('Error:', error);
        });
    },
    processSearch: function (value, form)
    {
        var url = form.getAttribute("action") + "?q=" + value;

        progress.show();

        window.location = url;
    }
};